/* global __DEV__ */
import * as Sentry from '@sentry/browser'
import util from 'util'

/*
Helper to intercept some console methods, and send them to Sentry.
It also may disable some console methods consoling for production, if desired
*/
const interceptConsole = (methods = [{ method: 'error', devOnly: true }]) => {
  methods.forEach(({ method, level, hideOnProductionConsole = false, sendToSentry = true }) => {
    if (!console[method]) return // Invalid method

    const oldConsoleMethod = console[method]
    console[method] = (...params) => {
      if (__DEV__ || !hideOnProductionConsole) { // Check if should console or block
        oldConsoleMethod(...params)
      }

      if (sendToSentry) {
        // If its an internal Sentry Logger error, simply finish procedure here
        // This avoid infinity loops of errors
        if (Array.isArray(params[0]) && params[0].includes('Sentry Logger')) {
          return
        }

        // Maps the input array elements (objects and arrays) to string
        const inspectedParams = params.map((param) => {
          if (typeof param === 'object') {
            return util.inspect(param, { showHidden: false, depth: null })
          } else {
            return param
          }
        })

        Sentry.withScope((scope) => {
          scope.setLevel(level)
          Sentry.captureMessage(inspectedParams.join(' '))
        })
      }
    }
  })
}

export const init = ({ dsn }) => {
  const { name, version } = require('../../../package.json')
  const env = __DEV__ ? 'development' : 'production'

  console.log(`Version ${version} - ${env} (${process.env.REACT_APP_ENV})`)

  if (env === 'production') {
    Sentry.init({
      dsn: dsn,
      release: `${name}@${version}`,
      environment: env,
      debug: __DEV__,
      attachStacktrace: true
    })
  }

  /*
  Defined that:
  console.error, and console.warn will be sent to sentry (And not written to local stream),
  console.info will be sent without local restrictions.
  Other consoles (Like console.log) won't be modified
  */
  interceptConsole([
    { method: 'log', level: 'debug', hideOnProductionConsole: true, sendToSentry: false },
    { method: 'info', level: 'debug', hideOnProductionConsole: false, sendToSentry: true },
    { method: 'warn', level: 'warning', hideOnProductionConsole: true, sendToSentry: true },
    { method: 'error', level: 'error', hideOnProductionConsole: true, sendToSentry: true }
  ])
}

export default { ...Sentry, init }



// WEBPACK FOOTER //
// ./src/components/globals/SentryHandler.web.js